import React from "react";
import {
  FollowingNoticesList,
  NoticesMedia,
} from "../../../model/notices/NoticesListModel";
import Loader from "../../../widget/common/ui/Loader";
import Center from "../../../widget/common/ui/Center";
import Div from "../../../widget/common/ui/Div";
import { SpacingHeight } from "../../../widget/common/ui/Spacing";
import { TextBlock } from "../../../widget/common/ui/Text";
import pdfIcon from "../../../assets/images/icons/pdf.png";
import fileIcon from "../../../assets/images/icons/file.png";
import AppConfigService from "../../../service/app_config/AppConfigService";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { imageExtensions, pdfExtensions } from "../../../const/FileExtensions";
import { LogoImage } from "../../../widget/common/ui/Logo";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import { navigate } from "../../../service/navigation/Navigation";
import { appRoutes } from "../../../routes/routes";
import SessionStorage from "../../../service/storage/SessionStorage";
import StorageKeys from "../../../const/StorageKeys";
import ModalKeys from "../../../const/ModalKeys";
import { addModal } from "../../../libraries/state_reducers/widget/ModalsReducer";
import { useDispatch } from "react-redux";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import SwipeCarousel, {
  SwipeCarouselImagesProps,
} from "../../../widget/common/ui/SwipeCarousel";

const NoticesDetailContent = (props: {
  detail: FollowingNoticesList | null;
  type?: number | undefined;
}) => {
  const dispatch = useDispatch();
  const noticeDetail = props.detail ?? null;
  const type: number = props.type ?? ResponsiveDeviceType();

  const sizeHeihgt = type === 1 ? 230 : 350;

  const imageDocHtml = (notice: FollowingNoticesList): JSX.Element => {
    let url: string = notice?.media_details?.file_url ?? "";
    const medialList: Array<NoticesMedia> = notice?.media_list ?? [];
    const name: string = notice?.title ?? AppConfigService.get("company_name");

    if (medialList.length === 0) {
      if (UtilityHelper.isEmpty(url)) {
        url = UtilityHelper.isNotEmpty(notice?.branch_logo_url!)
          ? notice?.branch_logo_url!
          : AppConfigService.get("company_logo");
      }

      if (UtilityHelper.isNotEmpty(url)) {
        const urlArr: string[] | undefined = url.split(".");
        const fileExt: string = urlArr![urlArr!.length - 1];
        let returnHtml: JSX.Element = <></>;

        if (imageExtensions.includes(fileExt)) {
          returnHtml = <LogoImage url={url} size={sizeHeihgt} name={name} />;
        } else if (pdfExtensions.includes(fileExt)) {
          returnHtml = (
            <img src={pdfIcon} style={{ height: sizeHeihgt }} alt="" />
          );
        } else {
          returnHtml = (
            <img src={fileIcon} style={{ height: sizeHeihgt }} alt="" />
          );
        }

        return (
          <div
            style={{ height: sizeHeihgt }}
            onClick={() => onCLickDocument(url)}
          >
            {returnHtml}
          </div>
        );
      }
    } else {
      let mediaListCarousel: Array<SwipeCarouselImagesProps> = [];
      medialList.forEach((item) => {
        const fileUrl: string = item.file_url!;
        const itemArr: string[] = fileUrl.split(".");
        const fileExt: string = itemArr![itemArr!.length - 1];

        if (imageExtensions.includes(fileExt)) {
          mediaListCarousel.push({ url: fileUrl, src: fileUrl });
        } else if (pdfExtensions.includes(fileExt)) {
          mediaListCarousel.push({ url: pdfIcon, src: fileUrl });
        } else {
          mediaListCarousel.push({ url: fileIcon, src: fileUrl });
        }
      });

      return (
        <SwipeCarousel
          images={mediaListCarousel}
          height={sizeHeihgt}
          onClickImage={onCLickDocument}
        />
      );
    }

    return <></>;
  };

  const onCLickDocument = (url: string) => {
    if (UtilityHelper.isNotEmpty(url)) {
      SessionStorage.saveValue(
        StorageKeys.preview_image_document,
        JSON.stringify({
          title: noticeDetail?.branch_title!,
          url: url,
        })
      );

      if (type === 3) {
        dispatch(
          addModal({
            id: ModalKeys.preview_image_document,
            title: AppTranslation.text("preview"),
          })
        );
      } else {
        navigate(appRoutes.routeNamePreviewImageDocs);
      }
    }
  };

  return (
    <>
      {noticeDetail == null ? (
        <Center className="h-100">{Loader.normal()}</Center>
      ) : (
        <Div className="pt-3">
          <div
            role={
              UtilityHelper.isNotEmpty(
                noticeDetail?.media_details?.file_url! ?? ""
              )
                ? "button"
                : "none"
            }
            className="bgcolor-grey d-center"
            style={{ height: sizeHeihgt }}
          >
            {imageDocHtml(noticeDetail)}
          </div>

          <SpacingHeight value={30} />
          <TextBlock
            fontName="book"
            fontSize="16_17"
            textColor="theme-sublabel"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: noticeDetail?.message!.replaceAll("\n", "<br />"),
              }}
            />
          </TextBlock>
        </Div>
      )}
    </>
  );
};

export default NoticesDetailContent;
